import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#6E6E7D",
      "stroke-width": ".656",
      d: "m5.672 10.266.328.328.164-.164.164-.164V7.64h-.656z",
      style: {"stroke":"color(display-p3 .4296 .4296 .4915)","stroke-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "#A7A7B1",
      d: "M2.719 7.314h-.41c0 .226.183.41.41.41zM4.28 4.518l.215.35.166-.103.025-.194zm3.438 0-.406.053.025.194.166.102zm1.562 2.796v.41a.41.41 0 0 0 .41-.41zM3.703.996a.41.41 0 0 0 0 .82zm4.594.82a.41.41 0 0 0 0-.82zM2.719 7.314h.41c0-1.034.546-1.94 1.367-2.447l-.215-.349-.216-.349A3.69 3.69 0 0 0 2.31 7.314zm5-2.796-.215.35a2.87 2.87 0 0 1 1.367 2.446h.82a3.69 3.69 0 0 0-1.756-3.145zm1.562 2.796v-.41H6v.82h3.281zM7.72 4.518l.407-.053-.407-3.112-.407.053-.406.053.407 3.112zm-.407-3.112v-.41H4.688v.82h2.625zm-2.625 0-.406-.053-.407 3.112.407.053.406.053.407-3.112zm0 0v-.41h-.984v.82h.985zm2.625 0v.41h.985v-.82h-.985zM2.72 7.314v.41H6v-.82H2.719z",
      style: {"fill":"color(display-p3 .6543 .6543 .6951)","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }